<script>
    import TheModalWrap from "@main/packages/TheModalWrap";
    import StatusOrder from "@/components/StatusOrder";

    export default {
        name: "ModalStatusOrder",
        components: {
            TheModalWrap,
            StatusOrder,
        },
        props: {
            statusOrderId: String,
        },
    };
</script>

<template>
    <the-modal-wrap title="Статус заказа">
        <status-order :status-order-id="statusOrderId"></status-order>
    </the-modal-wrap>
</template>
